import { FC } from 'react';
import { timeFormat } from 'd3-time-format';
import { timeDay } from 'd3-time';
import { ScaleTime } from 'd3-scale';
import React from 'react';
import { GraphLayoutDateAxis, GraphLayoutTimeAxis } from '../ChartPanel';
import { ScaleLinear } from 'd3-scale';

interface TimeAxisProps {
  timeScale: ScaleTime<number, number>;
}
interface PercentageAxisProps {
  scale: ScaleLinear<number, number>;
  color?: string;
}
const dayFormat = timeFormat('%m/%d/%Y');
const hourMinuteFormat = timeFormat('%H:%M');

const HorizontalDateAxis: FC<TimeAxisProps> = ({ timeScale }) => {
  const width = timeScale.range()[1];
  const axis = timeScale
    .ticks(timeDay)
    .filter(tick => timeScale(tick) > 25 && timeScale(tick) < width - 25)
    .map((tick, i) => (
      <text
        fill="#848484"
        x={timeScale(tick)}
        textAnchor="middle"
        y="10"
        height="10"
        fontSize="10"
        key={i}
      >
        {dayFormat(tick)}
      </text>
    ));
  return (
    <GraphLayoutDateAxis viewBox={`0 0 ${width >= 0 ? width : 0} 10`} width="100%">
      {axis}
    </GraphLayoutDateAxis>
  );
};

const HorizontalHoursAndMinutesAxis: FC<TimeAxisProps> = ({ timeScale }) => {
  const width = timeScale.range()[1];
  const axis = timeScale
    .ticks()
    .filter(tick => timeScale(tick) > 25 && timeScale(tick) < width - 25)
    .map((tick, i) => (
      <text
        fill="#848484"
        x={timeScale(tick)}
        textAnchor="middle"
        y="10"
        height="10"
        fontSize="10"
        key={i}
      >
        {hourMinuteFormat(tick)}
      </text>
    ));
  return (
    <GraphLayoutTimeAxis viewBox={`0 0 ${width >= 0 ? width : 0} 10`} width="100%">
      {axis}
    </GraphLayoutTimeAxis>
  );
};

const HorizontalPercentageAxis: FC<PercentageAxisProps> = ({ scale, color }) => {
  const width = scale.range()[1];
  const axis = scale.ticks().map((tick, i, arr) => {
    let anchor = 'middle';
    if (tick === 100) {
      anchor = 'end';
    }
    if (tick === 0) {
      anchor = 'start';
    }
    return (
      <text x={scale(tick)} textAnchor={anchor} y="10" height="10" fontSize="10" key={i}>
        {tick}%
      </text>
    );
  });
  return (
    <GraphLayoutTimeAxis
      width="100%"
      fill={color || '#848484'}
      viewBox={`0,0,${width >= 0 ? width : 0},10`}
    >
      {axis}
    </GraphLayoutTimeAxis>
  );
};

export { HorizontalDateAxis, HorizontalHoursAndMinutesAxis, HorizontalPercentageAxis };
